import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingEstablishmentChoiceEntryProposalStatus } from "@/features/maintenance/features/workflows/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

const DirectiveEntryDiagnosticEntryOnGoingEstablishmentChoice = () => {
  const { forwarding } = useForwardingTabContext();

  const actualProposalStatus = forwarding.establishment_choice_entry.actual_proposal.status;

  if (actualProposalStatus === MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.AwaitingEstablishmentResponse) {
    return (
      <p className="text-white-300">
        Aguardando envio de lance
      </p>
    );
  }

  if (actualProposalStatus === MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.AwaitingClientResponse) {
    return (
      <p className="text-white-300">
        Aguardando aprovação
      </p>
    );
  }

  if (actualProposalStatus === MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.Canceled) {
    return (
      <p className="text-danger-soft">
        Proposta declinada
      </p>
    );
  }

  return null;
}

export default DirectiveEntryDiagnosticEntryOnGoingEstablishmentChoice;
